@if (showBackButton$ | async) {
  <ds-results-back-button [back]="back"></ds-results-back-button>
}
@if (iiifEnabled) {
  <div class="row">
    <div class="col-12">
      <ds-mirador-viewer  id="iiif-viewer"
        [object]="object"
        [searchable]="iiifSearchEnabled"
        [query]="iiifQuery$ | async">
      </ds-mirador-viewer>
    </div>
  </div>
}
<div class="d-flex flex-row">
  <ds-item-page-title-field [item]="object" class="me-auto">
  </ds-item-page-title-field>
  <ds-dso-edit-menu></ds-dso-edit-menu>
</div>

<div class="row mt-3">
  <div class="col-12 col-md-4">
    @if (!(mediaViewer.image || mediaViewer.video)) {
      <ds-metadata-field-wrapper [hideIfNoTextContent]="false">
        <ds-thumbnail [thumbnail]="object?.thumbnail | async"></ds-thumbnail>
      </ds-metadata-field-wrapper>
    }
    @if (mediaViewer.image || mediaViewer.video) {
      <div class="mb-2">
        <ds-media-viewer [item]="object"></ds-media-viewer>
      </div>
    }
    <ds-item-page-file-section [item]="object"></ds-item-page-file-section>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.type']"
      [label]="'publication.page.type'">
    </ds-generic-item-page-field>
    
    <ds-generic-item-page-field [item]="object"
      [fields]="['local.type']"
      [label]="'publication.page.extensaotype'">
    </ds-generic-item-page-field>

    <ds-item-page-date-field [item]="object"></ds-item-page-date-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.date.created']"
      [label]="'publication.page.datecreated'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['local.description.rights']"
      [label]="'publication.page.rights'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.coverage.spatial']"
      [label]="'publication.page.spatial'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.format.extent']"
      [label]="'publication.page.extent'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.publisher']"
      [label]="'publication.page.publisher'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['local.software.version']"
      [label]="'publication.page.softwareversion'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.relation.haspart']"
      [label]="'publication.page.haspart'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.relation.hasversion']"
      [label]="'publication.page.hasversion'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.relation.ispartofseries']"
      [label]="'publication.page.ispartofseries'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['local.patent.publisher']"
      [label]="'publication.page.patentpublisher'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.identifier.other']"
      [label]="'publication.page.idother'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.identifier.doi']"
      [label]="'publication.page.doi'">
    </ds-generic-item-page-field>
    
    <ds-item-page-uri-field [item]="object"
      [fields]="['dc.identifier.uri']"
      [label]="'item.page.uri'">
    </ds-item-page-uri-field>

    <ds-item-page-collections [item]="object"></ds-item-page-collections>
  </div>

  <div class="col-12 col-md-7">
    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
      [parentItem]="object"
      [itemType]="'Person'"
      [metadataFields]="['dc.contributor.author']"
      [label]="'item.page.authors' | translate">
    </ds-metadata-representation-list>

    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
      [parentItem]="object"
      [itemType]="'Person'"
      [metadataFields]="['local.contributor.inventor']"
      [label]="'item.page.inventors' | translate">
    </ds-metadata-representation-list>

    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
      [parentItem]="object"
      [itemType]="'Person'"
      [metadataFields]="['local.contributor.organizer']"
      [label]="'item.page.organizers' | translate">
    </ds-metadata-representation-list>

    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
      [parentItem]="object"
      [itemType]="'Person'"
      [metadataFields]="['dc.contributor.advisor']"
      [label]="'item.page.advisors' | translate">
    </ds-metadata-representation-list>

    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
      [parentItem]="object"
      [itemType]="'Person'"
      [metadataFields]="['local.contributor.coadvisor']"
      [label]="'item.page.coadvisors' | translate">
    </ds-metadata-representation-list>

    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
      [parentItem]="object"
      [itemType]="'Person'"
      [metadataFields]="['local.contributor.board']"
      [label]="'item.page.board' | translate">
    </ds-metadata-representation-list>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.contributor.other']"
      [label]="'publication.page.contribother'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['local.contributor.titular']"
      [label]="'publication.page.titular'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['local.patent.assignee']"
      [label]="'publication.page.assignee'">
    </ds-generic-item-page-field>

    @if (object.metadata['dc.description.abstract']; as abstracts) {
      @for (abstract of abstracts; track abstract) {
        @if (abstract.language?.toLowerCase()?.startsWith('pt')) {
          <div class="simple-view-element">
            <h2 class="simple-view-element-header">Resumo</h2>
            <div class="simple-view-element-body" [innerHTML]="abstract.value"></div>
          </div>
        }

        @if (abstract.language?.toLowerCase()?.startsWith('en')) {
          <div class="simple-view-element">
            <h2 class="simple-view-element-header">Abstract</h2>
            <div class="simple-view-element-body" [innerHTML]="abstract.value"></div>
          </div>
        }
      }
    }

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.description']"
      [label]="'publication.page.description'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['local.format.requires']"
      [label]="'publication.page.requires'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.relation.ispartof']"
      [label]="'publication.page.ispartof'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.identifier.isbn']"
      [label]="'publication.page.isbn'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.identifier.issn']"
      [label]="'publication.page.issn'">
    </ds-generic-item-page-field>

    <ds-item-page-uri-field [item]="object"
      [fields]="['local.identifier.sourceuri']"
      [label]="'item.page.sourceuri'">
    </ds-item-page-uri-field>

    <ds-item-page-uri-field [item]="object"
      [fields]="['dc.relation.uri']"
      [label]="'item.page.relationuri'">
    </ds-item-page-uri-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.subject']"
      [separator]="', '"
      [label]="'item.page.subject'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['local.description.tecnologia']"
      [separator]="', '"
      [label]="'item.page.tecnologias'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.subject.classification']"
      [separator]="', '"
      [label]="'item.page.subjectclassification'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['local.patent.classification']"
      [separator]="', '"
      [label]="'item.page.patentclassification'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.identifier.citation']"
      [label]="'item.page.citation'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.description.sponsorship']"
      [label]="'publication.page.sponsorship'">
    </ds-generic-item-page-field>

    <ds-item-page-uri-field [item]="object"
      [fields]="['coar.notify.endorsedBy']"
      [label]="'item.page.endorsement'">
    </ds-item-page-uri-field>
    <ds-item-page-uri-field [item]="object"
      [fields]="['datacite.relation.isReviewedBy']"
      [label]="'item.page.review'">
    </ds-item-page-uri-field>
    <ds-item-page-uri-field [item]="object"
      [fields]="['datacite.relation.isSupplementedBy']"
      [label]="'item.page.supplemented'">
    </ds-item-page-uri-field>
    <ds-item-page-uri-field [item]="object"
      [fields]="['datacite.relation.isReferencedBy']"
      [label]="'item.page.referenced'">
    </ds-item-page-uri-field>
    @if (geospatialItemPageFieldsEnabled) {
      <ds-geospatial-item-page-field [item]="object"
                                     [label]="'item.page.places'"
                                     [pointFields]="['dcterms.spatial']"
                                     [bboxFields]="['dcterms.spatial']"
                                     [cluster]="true"
      >
      </ds-geospatial-item-page-field>
    }
    <div>
      <a class="btn btn-outline-primary" role="button" [routerLink]="[itemPageRoute + '/full']" role="button" tabindex="0">
        <i class="fas fa-info-circle"></i> {{"item.page.link.full" | translate}}
      </a>
    </div>
  </div>
</div>
